import Column from '@components/column'
import Banner from './banner'
import List from './list'
import TodayAppointments from '@commons/lists/todayAppointments'
import NextAppointment from '@commons/cards/nextScheduleAppointment'

const InstituteAppointmentsPage = () => {
  return (
    <Column rowGap={20}>
      <Banner />
      <NextAppointment />
      <TodayAppointments />
      <List />
    </Column>
  )
}

export default InstituteAppointmentsPage
